import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import {NgxPaginationModule} from 'ngx-pagination';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgxSelectModule } from 'ngx-select-ex';

import { VMessageModule } from '../shared/components/vmessage/vmessage.module';
import { CardModule } from '../shared/components/card/card.module';
import { PrestadorComponent } from './prestador.component';
import { PrestadorService } from './prestador.service';
import { PrestadorProcedimentoComponent } from './prestador-procedimentos/prestador-procedimento.component';

@NgModule({
    declarations: [
      PrestadorComponent,
      PrestadorProcedimentoComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        NgxMaskDirective,
        NgxMaskPipe,
        NgxPaginationModule,

        CardModule,
        ReactiveFormsModule,
        NgbModule,
        VMessageModule,
        RouterModule,
        CurrencyMaskModule,
        NgxSelectModule,
    ],
    providers: [ PrestadorService ]
})
export class PrestadorModule { }
